import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GetRates } from 'src/app/models/rates.model';

import { Brochure } from 'src/app/models/Brochure.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})

export class RatesService {

  apiUrl = 'CheckRates';
  model: GetRates = {
    state: '',
    policyNo: 0
  }

  constructor(private http: HttpClient) { }

  getRates(state :string, policyNo: number): Observable<any> {
 
    this.model.state = state;
    this.model.policyNo = policyNo;

    return this.http.post<any>(environment.baseUrl + this.apiUrl +'/GetCheckRates',this.model.policyNo);
  
  }
  getBrochure(policyNo: number): Observable<Brochure[]> {
    return this.http.post<Brochure[]>(environment.baseUrl + this.apiUrl + '/GetBrochures', policyNo);
  }
}
